var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hiq-politicians-search"},[(_vm.isSearch)?_c('search-form'):_vm._e(),(_vm.isSearch)?_c('search-info'):_vm._e(),(_vm.isSearch)?_c('filters-component'):_vm._e(),_c('hits-component'),_c('pagination-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }